// extracted by css-extract-rspack-plugin
export default {"root":"styles-module__root__pVRG9","grid":"styles-module__grid__jtIeT"};